import { useEffect, useState } from 'react';

export type LayoutMode = 'topbar' | 'sidebar';

export default function useCustomLayoutMode() {
  const [layoutMode, setLayoutMode] = useState<LayoutMode>('sidebar');

  useEffect(() => {
    const stored = localStorage.getItem('__secu_layout_mode') as LayoutMode | null;
    if (stored) {
      setLayoutMode(stored);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('__secu_layout_mode', layoutMode);
  }, [layoutMode]);

  return [layoutMode, setLayoutMode] as const;
}
